/**
 * Exports container-related design tokens
 */

export const width = 156;
export const horizontalPadding = {
    small: 2,
    medium: 3,
};